import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import { StyledCommonProps } from "../../utils/styled";

const Right = styled.div`
  margin-left: auto;
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const ToolbarWrapper = styled.div<{ stretch?: boolean }>`
  display: flex;
  gap: 0.5rem;
  align-items: center;

  ${({ stretch }) => stretch && "width: 100%;"}

  ${Right} {
    gap: inherit;
  }
`;

const Flex = styled.div`
  flex: 1;
`;

export interface WrappedProps<T> extends React.FC<T> {
  Right: typeof Right;
  Flex: typeof Flex;
}

type ToolbarProps = WrappedProps<
  StyledCommonProps & {
    stretch?: boolean;
  }
>;

const ToolbarComponent = ({
  children,
  ...props
}: PropsWithChildren<ToolbarProps>) => (
  <ToolbarWrapper {...props}>{children}</ToolbarWrapper>
);

ToolbarComponent.Flex = Flex;
ToolbarComponent.Right = Right;

const Toolbar: any = styled(ToolbarComponent)``;

export default Toolbar;
